export default __webpack_public_path__ + "static/media/falcon_join_hover_1.b7606968.svg";